import { createContext, useContext } from "react";

const WhoIsOnlineContext = createContext({});

export const WhoIsOnlineContextProvider = WhoIsOnlineContext.Provider;
export const WhoIsOnlineContextConsumer = WhoIsOnlineContext.Consumer;

export const useWhoIsOnlineContext = () => useContext(WhoIsOnlineContext);

export default WhoIsOnlineContext;
